import classNames from 'classnames';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { s as styles } from '../spoiler-acc8c283.js';
import { SPOILER_TYPE } from '../types.js';
import SpoilerContainer from './SpoilerContainer.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../icons/SpoilerContainerIcon.js';
import './RevealButton.js';
import './EditableInputWrapper.js';
import './SpoilerDescriptionInput.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const Overlay = ({ hideOverlay, pluginType }) => !hideOverlay ? /* @__PURE__ */ React.createElement(
  "div",
  {
    role: "none",
    className: pluginType === "Gallery" ? styles.overlay_gallery : styles.overlay
  }
) : null;
Overlay.propTypes = {
  hideOverlay: PropTypes.bool,
  pluginType: PropTypes.string
};
class BlockSpoilerComponent extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "onResizeElement", () => {
      this.forceUpdate();
    });
    __publicField(this, "handleClick", (e) => {
      const { onClick } = this.props;
      const { isReveal } = this.state;
      isReveal && (onClick == null ? void 0 : onClick(e));
    });
    __publicField(this, "onRevealSpoiler", (e) => {
      var _a;
      const { helpers, pluginType } = this.props;
      e.preventDefault();
      this.setState({ isReveal: true });
      (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, SPOILER_TYPE, "Click", `reveal_${pluginType}`);
    });
    __publicField(this, "renderSpoilerContainer", () => {
      var _a, _b, _c, _d, _e, _f;
      const { isReveal } = this.state;
      const {
        disabledRevealSpoilerBtn,
        setFocusToBlock,
        componentData,
        pluginType,
        setInPluginEditingMode,
        handleButtonContentChange,
        handleDescriptionChange,
        isMobile,
        t,
        helpers
      } = this.props;
      const width = (_a = this.elementRef) == null ? void 0 : _a.offsetWidth;
      const height = (_b = this.elementRef) == null ? void 0 : _b.offsetHeight;
      return !isReveal && /* @__PURE__ */ React.createElement(
        SpoilerContainer,
        {
          styles,
          width,
          height,
          setInPluginEditingMode,
          setFocusToBlock,
          pluginType,
          description: (_d = (_c = componentData == null ? void 0 : componentData.config) == null ? void 0 : _c.spoiler) == null ? void 0 : _d.description,
          buttonContent: (_f = (_e = componentData == null ? void 0 : componentData.config) == null ? void 0 : _e.spoiler) == null ? void 0 : _f.buttonContent,
          onRevealSpoiler: !disabledRevealSpoilerBtn ? this.onRevealSpoiler : void 0,
          handleButtonContentChange,
          handleDescriptionChange,
          isMobile,
          t,
          helpers
        }
      );
    });
    __publicField(this, "onKeyDown", (e) => {
      if (e.key === "Enter") {
        this.handleClick(e);
      }
    });
    __publicField(this, "setRef", (ref) => this.elementRef = ref);
    this.state = {};
  }
  componentDidMount() {
    var _a;
    if (window == null ? void 0 : window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(debounce(this.onResizeElement, 60));
      (_a = this.resizeObserver) == null ? void 0 : _a.observe(this.elementRef);
    }
  }
  componentWillUnmount() {
    var _a;
    if (window == null ? void 0 : window.ResizeObserver) {
      (_a = this.resizeObserver) == null ? void 0 : _a.unobserve(this.elementRef);
    }
  }
  render() {
    var _a;
    const { children, pluginType, width, isMobile } = this.props;
    const { isReveal } = this.state;
    let className = "";
    let blur = "";
    if (!isReveal) {
      const isGallery = pluginType === "Gallery";
      className = isGallery ? styles.hideBlock_gallery : styles.hideBlock;
      if (!isGallery) {
        const width2 = (_a = this.elementRef) == null ? void 0 : _a.offsetWidth;
        blur = width2 < 400 ? styles.smallBlur : width2 < 700 ? styles.mediumBlur : styles.largeBlur;
      }
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: this.setRef,
        className: classNames(styles.spoilerWrapper, this.props.className, {
          [styles.isMobile]: isMobile
        }),
        style: { width },
        "data-hook": "spoilerContainer"
      },
      this.renderSpoilerContainer(),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(className, blur),
          onClick: this.handleClick,
          role: "button",
          tabIndex: 0,
          onKeyDown: this.onKeyDown
        },
        children,
        /* @__PURE__ */ React.createElement(Overlay, { hideOverlay: isReveal, pluginType })
      )
    );
  }
}
BlockSpoilerComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
  theme: PropTypes.object,
  disabledRevealSpoilerBtn: PropTypes.bool,
  isEditableText: PropTypes.bool,
  pluginType: PropTypes.string,
  onClick: PropTypes.func,
  handleDescriptionChange: PropTypes.func,
  handleButtonContentChange: PropTypes.func,
  className: PropTypes.string,
  setFocusToBlock: PropTypes.func,
  setInPluginEditingMode: PropTypes.func,
  width: PropTypes.object,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
  helpers: PropTypes.object,
  type: PropTypes.string
};

export { BlockSpoilerComponent as default };
//# sourceMappingURL=BlockSpoilerComponent.js.map
